import { BitfNetRequestMapper } from '@common/libs/bitforce/core/parsers/net-parser';
import { EBitfParsers } from '@enums';

export class AppRequestMapper extends BitfNetRequestMapper {
  name = EBitfParsers.BITF_APP_PARSER;
}
